import type React from 'react';
import { useState } from 'react';

import { EyeIcon, EyeShowIcon } from '../../../assets/icons';
import type { Props } from '../Input/Input';
import Input from '../Input/Input';

const Password: React.FC<Props> = ({ hideEye, ...props }) => {
  const [type, setType] = useState<Props['type']>('password');
  const toggleType = () => setType(type === 'password' ? 'text' : 'password');
  const Icon = type === 'password' ? EyeIcon : EyeShowIcon;

  return (
    <Input {...props} showValidationTick={false} type={type}>
      {!hideEye && <Icon onClick={toggleType} />}
      {props.children}
    </Input>
  );
};

export default Password;
